module.exports = __webpack_public_path__ + "static/media/donbosco15.c3da538a.jpg";